<script>
export default {
  name: 'ApartmentBloc',
  data() {
    return {
      apartment: {
        apart_bloc: '',
        apart_address: '',
        cited_id: 1,
      },
    }
  },
  methods: {
    newApartment() {
      this.$axios.post(this.$endpoint.CreateApartment, this.apartment).then(rp => {
        console.log(rp)
      })
    },
  },
}
</script>

<template>
  <div>
    <v-row>
      <v-col
          cols="12"
          md="12"
      >
            <span
                class="text-lg-h5  mb-4"
                style="justify-content: center; display: flex;"
            >
              Nouveau block
            </span>
      </v-col>
    </v-row>
    <v-form
        class="multi-col-validation"
        style="margin-top:1rem;margin-left: 1rem; margin-bottom: 1.5rem;"
    >
      <v-row>
        <v-col
            cols="12"
            md="6"
        >
          <v-text-field
              v-model="apartment.apart_bloc"
              dense
              hide-details
              label="Nom"
              outlined
              placeholder="Designation"
          ></v-text-field>
        </v-col>

        <v-col
            cols="12"
            md="6"
        >
          <v-text-field
              v-model="apartment.apart_address"
              dense
              hide-details
              label="Addresse"
              outlined
              placeholder="Lieu"
          ></v-text-field>
        </v-col>

        <v-col
            cols="12"
            md="6"
        >
        </v-col>

        <v-col cols="12">
        </v-col>

        <v-col cols="12">
          <v-btn
              color="primary"
              @click="newApartment"
          >
            Creer
          </v-btn>
          <v-btn
              class="mx-2"
              outlined
              type="reset"
          >
            Annuler
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<style scoped>

</style>